import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { withRouter, routerShape } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import './SearchScopeField.scss';

export class SearchScopeField extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderScopeLink');
  }

  getHrefForScope(searchScope) {
    const { createHref, location } = this.props.router;
    return createHref({
      ...location,
      query: {
        ...location.query,
        searchScope,
        lastSearchScope: location.query.searchScope
      }
    });
  }

  renderScopeLink(scope, index) {
    const linkClasses = classNames('filter', { applied: this.props.currentSearchScope === scope.get('scopeId') });

    const styles = {
      paddingLeft: `${index <= 1 ? 0 : (index - 1)}em`
    };

    return (
      <li className={linkClasses} style={styles}>
        <a
          href={this.getHrefForScope(scope.get('scopeId'))}
          data-scope-id={scope.get('scopeId')}
          onClick={this.updateScope}>
          {index > 0 ? '\u2014 ' : ''}
          {scope.get('scopeName')}
        </a>
      </li>
    );
  }

  render() {
    return (
      <section className="cp-search-scope-field">
        <FormattedMessage id="section_title_show_results_at">
          {(message) => (<h4 className="field-name">{message}</h4>)}
        </FormattedMessage>
        <ul className="filter-list">
          {this.props.scopes.map(this.renderScopeLink)}
        </ul>
      </section>
    );
  }
}

SearchScopeField.displayName = 'SearchScopeField';
SearchScopeField.propTypes = {
  currentSearchScope: PropTypes.string.isRequired,
  router: routerShape,
  scopes: PropTypes.arrayOf(PropTypes.shape({
    scopeName: PropTypes.string.isRequired,
    scopeId: PropTypes.string.isRequired,
    parentScopeId: PropTypes.string.isRequired
  }).isRequired).isRequired
};

export default withRouter(SearchScopeField);



// WEBPACK FOOTER //
// ./app/components/search/SearchScopeField/SearchScopeField.jsx